import { Card, Button } from '@codeparva/ui-components-library';
import React from 'react';
import { RatesComponent } from './RatesComponent';
import { AmenitiesComponent } from './AmenitiesComponent';
import { UnitCardTypes } from '../../UnitCardTypes';
import { weakKey } from '../../../../utilities/weakKey';
import { Accordion } from '../../components/Accordian';
import { useSectionData } from '../../../../sections/rentalPage/components/dynamicForm/hooks/dataContext';

export const CardComponent = ({
  unitCardsConfig,
  foundData,
  selectChangedValue,
  values,
  selected,
  rate,
  ratesDetails,
  iconsList,
  isConfirmationPage,
  showModalTable,
  path,
  rentalinfoRes,
  updatedRate,
  isSurchargeOrDiscountAvailable,
  modifierType,
}: UnitCardTypes.TCardComponent) => {
  const { unitTypeCategory, amenitiesList, unitTypeName } = foundData;
  const {
    cardHeading,
    unitTypeHeading,
    amenitiesHeading,
    callToAction,
    billingCycleDetails,
    unitNumberHeading,
  } = unitCardsConfig;
  const ratesInfo = {
    unitCardsConfig,
    foundData,
    selected,
    ratesDetails,
    isAccordian: false,
    theme: 'dark',
    iconsList,
    path,
    rentalinfoRes,
    updatedRate,
    isSurchargeOrDiscountAvailable,
    modifierType,
  };
  const {
    individualUnitDataContext: { selectedUnitData },
  } = useSectionData();
  const SingleDropDownOption = () => {
    return <div className="subtitle1">{values[0]}</div>;
  };
  const MultiDropDownOption = () => {
    return (
      <select defaultValue={selected} onChange={selectChangedValue}>
        <option value="none" disabled hidden>
          {selected}
        </option>
        {values.map(value => (
          <option key={weakKey(values)}>{value}</option>
        ))}
      </select>
    );
  };
  const ShowCard = () => {
    return (
      <div className="unitDetailsSection">
        <h5 className="unitDetailsHeading has-text-text">{cardHeading}</h5>
        <div className="unitTypeDetails">
          <p className="unitTypeHeading has-text-text">{unitTypeHeading}</p>
          <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center py-4">
            <div className="unitTypeDiv">
              <p className="has-text-text subtitle1">{unitTypeName}</p>
              <p className="has-text-text subtitle1">
                {unitTypeCategory || ''}
              </p>
            </div>
            {callToAction.show && (
              <Button
                type="button"
                className="cp-outline-button-highlighted changeButton"
                onClick={() => {
                  showModalTable();
                }}
              >
                {callToAction.label}
              </Button>
            )}
          </div>
          {selectedUnitData && selectedUnitData.show && (
            <>
              <p className="unitTypeHeading has-text-text mt-2">
                {unitNumberHeading}
              </p>
              <div className="unitTypeDiv">
                <p className="unitTypePara has-text-text subtitle1">
                  {selectedUnitData.selectedUnitLabel}
                </p>
              </div>
            </>
          )}
          {path?.includes('move-in') && (
            <div className="billingCycleSection">
              <p className="billingCycleTitle">{billingCycleDetails.title}</p>
              <div className="select">
                {values.length <= 1 ? (
                  <SingleDropDownOption />
                ) : (
                  <MultiDropDownOption />
                )}
              </div>
            </div>
          )}
        </div>
        <AmenitiesComponent
          amenitiesList={amenitiesList}
          amenitiesHeading={amenitiesHeading}
        />
        <RatesComponent {...ratesInfo} />
      </div>
    );
  };
  const ShowAccordian = () => {
    const accordianData = {
      unitCardsConfig,
      foundData: foundData,
      theme: 'dark',
      rate,
      selected,
      iconsList,
      amenitiesList,
      amenitiesHeading,
      unitDetailsHeader: 'Unit Details',
      unitCardAccordianTitle: 'Summary',
      path,
      rentalinfoRes,
    };
    return <Accordion {...accordianData} />;
  };
  return (
    <Card className="unitCardContainer" marginless>
      <Card.Content className="cardContent">
        {isConfirmationPage ? <ShowAccordian /> : <ShowCard />}
      </Card.Content>
    </Card>
  );
};
